(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["insta-vedio"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', function() {
  if (window.Swiper) {
    new Swiper('.video-carousel-swiper', {
    slidesPerView: 'auto',
    spaceBetween: 28,
    loop: false,

    navigation:{
        nextEl:'.swiper-button-next',
        prevEl:'.swiper-button-prev'
    },

    pagination:{
        el:'.swiper-pagination',
        clickable:true
    }
});
  }
  const modal = document.getElementById('video-modal');
const player = document.getElementById('video-modal-player');
const closeBtn = document.querySelector('.video-modal-close');
const nextBtn = document.getElementById('video-next');
const prevBtn = document.getElementById('video-prev');

let currentIndex = 0;
const slides = document.querySelectorAll('.video-carousel-swiper .swiper-slide');

function showModal(index) {
  const videoTag = slides[index].querySelector('video');
  if (!videoTag) return;

  const source = videoTag.querySelector('source')?.src || videoTag.src;
  player.src = source;
  modal.classList.remove('hidden');
  currentIndex = index;

  // Product info
    const slide = slides[index];
    const productImg = slide.querySelector('.video-card-product-image')?.src;
    const productTitle = slide.querySelector('.video-card-product-title')?.textContent;
    const productPrice = slide.querySelector('.video-card-product-price')?.textContent;
    const productCompare = slide.querySelector('.video-card-product-compare')?.textContent;
    const productUrl = slide.querySelector('.video-card-product-image')?.closest('div')?.dataset.productUrl;
    const productInfoHTML = `
      <a href="${productUrl || '#'}">
      ${productImg ? `<img src="${productImg}" alt="${productTitle}" />` : ''}
      <div class="video-modal-product-info-title">${productTitle || ''}</div>
      <div class="video-modal-product-info-prices">
        ${productPrice ? `<span class="video-modal-product-info-price">${productPrice}</span>` : ''}
        ${productCompare ? `<span class="video-modal-product-info-compare">${productCompare}</span>` : ''}
      </div>
      <span class="video-modal-product-shopnow"><span>Shop now</span><span> > </span></span>
      </a>
    `;
    
    document.getElementById('video-modal-product-info').innerHTML = productInfoHTML;

}

function closeModal() {
  modal.classList.add('hidden');
  player.pause();
  player.src = '';
}

function showNext() {
  const nextIndex = (currentIndex + 1) % slides.length;
  showModal(nextIndex);
}

function showPrev() {
  const prevIndex = (currentIndex - 1 + slides.length) % slides.length;
  showModal(prevIndex);
}

slides.forEach((slide, index) => {
  slide.addEventListener('click', () => showModal(index));
});

closeBtn.addEventListener('click', closeModal);
nextBtn.addEventListener('click', showNext);
prevBtn.addEventListener('click', showPrev);

document.querySelector('.video-modal-overlay').addEventListener('click', closeModal);
const soundToggle = document.getElementById('video-sound-toggle');

soundToggle.addEventListener('click', () => {
  player.muted = !player.muted;
  soundToggle.textContent = player.muted ? '🔇' : '🔊';
});

});

  } catch(e) { console.error(e); }
})();
})();
